import { FacebookUserModel } from '../../shared/models/facebook.user.model';
import { GoogleUserModel } from '../../shared/models/google.user.model';
import { Subject } from 'rxjs/Subject';

export class UnauthenticatedUserRepositoryService {
    private emailChangedSource = new Subject<any>();
    protected email = '';
    protected name1 = '';
    protected name2 = '';
    protected socialUid = '';
    protected socialNetwork = '';
    protected socialUser: FacebookUserModel|GoogleUserModel;
    protected emailExists = false;
    public emailChanged$ = this.emailChangedSource.asObservable();

    /**
     * 'emailExists' getter.
     **/
    public exists(): boolean {
        return this.emailExists;
    }
    /**
     * 'email' property setter.
     **/
    public setEmail(email: string) {
        this.email = email;
        this.emailChangedSource.next(email);
    }
    /**
     * 'name1' property setter.
     **/
    public setName1(name: string) {
        this.name1 = name;
    }
    /**
     * 'name2' property setter.
     **/
    public setName2(name: string) {
        this.name2 = name;
    }
    /**
     * 'socialNetwork' property setter.
     **/
    public setSocialNetwork(network: string) {
        this.socialNetwork = network;
    }
    /**
     * 'socialUid' property setter.
     **/
    public setSocialUid(socialUid: string) {
        this.socialUid = socialUid;
    }
    /**
     * 'socialUser' property setter.
     **/
    public setSocialUser(user: FacebookUserModel|GoogleUserModel) {
        this.socialUser = user;
    }
    /**
     * 'email' property getter.
     **/
    public getEmail(): string {
        return this.email;
    }
    /**
     * 'name1' property getter.
     **/
    public getName1(): string {
        return this.name1;
    }
    /**
     * 'name2' property getter.
     **/
    public getName2(): string {
        return this.name2;
    }
    /**
     * 'socialNetwork' property getter.
     **/
    public getSocialNetwork(): string {
        return this.socialNetwork;
    }
    /**
     * 'socialUid' property getter.
     **/
    public getSocialUid(): string {
        return this.socialUid;
    }
    /**
     * 'socialUser' property getter.
     **/
    public getSocialUser(): FacebookUserModel|GoogleUserModel {
        return this.socialUser;
    }
    /**
     * Returns true if has some socialUid setted.
     **/
    public isSocial(): boolean {
        return this.socialUid !== '';
    }
    /**
     * 'emailExists' property setter.
     **/
    public setEmailExists(exists: boolean) {
        this.emailExists = exists;
    }
    /**
     * Reset all values to empty.
     **/
    public reset() {
        this.setName1('');
        this.setName2('');
        this.setSocialUid('');
        this.setSocialNetwork('');
        this.setSocialUser(null);
        this.email = '';
        this.emailExists = false;
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src1143190010/src/src/app/payment/services/unauthenticated-user-repository.service.ts